// Lightweight home-page content: only what the Index page actually renders.
// Keeping this separate from articles.ts is critical for LCP — articles.ts
// imports ~60 gallery JPEGs that vite-react-ssg would otherwise auto-preload
// in the home chunk, saturating the connection on mobile.
// Update whenever a new article is published.




import rossanoPodioAsset from "@/assets/blog/rossano-2026-podio.jpg.asset.json";
import rossanoFlaviaMedagliaAsset from "@/assets/blog/rossano-2026-flavia-medaglia.jpg.asset.json";
import arezzoFratelliAsset from "@/assets/blog/arezzo-2026-fratelli.jpg.asset.json";
import arezzoMatteoMedagliaAsset from "@/assets/blog/arezzo-2026-matteo-medaglia.jpg.asset.json";
import messinaPodioAsset from "@/assets/blog/stagione-2026-messina-podio.jpeg.asset.json";
import kimLiuRoma07Asset from "@/assets/blog/kim-liu-roma-2026-07.jpeg.asset.json";

export interface HomeArticleCard {
  id: string;
  title: string;
  slug: string;
  excerpt: string;
  category: "bambini" | "ragazzi" | "adulti" | "generale" | "zona" | "agonisti";
  publishedAt?: string;
}

// Latest 3 published articles — mirrors articles.ts head
export const latestArticleCards: HomeArticleCard[] = [
  {
    id: "50",
    title: "Taekwondo, grandi soddisfazioni a Formia: Matteo Gasbarre diventa allenatore e Valerio Venanzi conquista il 5° DAN",
    slug: "formia-2026-matteo-gasbarre-allenatore-valerio-venanzi-quinto-dan",
    excerpt: "Al Centro di Preparazione Olimpica di Formia, Matteo Gasbarre conquista la qualifica di allenatore e Valerio Venanzi raggiunge il 5° DAN: due traguardi per il Taekwondo Mattei.",
    category: "generale",
    publishedAt: "2026-10-26",
  },
  {
    id: "49",
    title: "L’Accademia Mattei cresce: passione, qualità e giovani talenti",
    slug: "accademia-mattei-crescita-giovani-talenti-2026",
    excerpt: "L’Accademia Mattei continua a crescere grazie alla fiducia delle famiglie, all’entusiasmo dei ragazzi e al lavoro dello staff: sport, educazione e nuovi giovani talenti.",
    category: "generale",
    publishedAt: "2026-10-21",
  },
  {"id": "48", "title": "Il Taekwondo Mattei Roma ai Campionati Italiani: un argento che ci riempie d’orgoglio!", "slug": "campionati-italiani-rossano-2026-argento-flavia-marcellini", "excerpt": "Dal 16 al 18 ottobre a Rossano, Matteo e Andrea Gasbarre e Flavia Marcellini rappresentano il Taekwondo Mattei Roma: argento per Flavia nei -53 kg Senior cinture rosse.", "category": "agonisti", "publishedAt": "2026-10-18"},
  {
    id: "47",
    title: "Interregionale di Arezzo: la stagione agonistica riparte con due fratelli sul tatami",
    slug: "interregionale-arezzo-2026-prima-gara-stagione",
    excerpt:
      "Il Taekwondo Mattei apre la stagione agonistica all'Interregionale di Arezzo: Matteo Gasbarre torna sul tatami nei -68 kg Senior, Andrea Gasbarre disputa tre incontri nei -55 kg Junior. Prossimo appuntamento: i Campionati Italiani.",
    category: "agonisti",
    publishedAt: "2026-10-05",
  },
  {
    id: "46",
    title: "Ripartenza corsi: la nuova stagione inizia mercoledì 2 settembre",
    slug: "ripartenza-corsi-settembre-2026",
    excerpt:
      "I corsi del Taekwondo Mattei Roma ripartono mercoledì 2 settembre 2026: turno bambini e ragazzi 17:00-18:15, turno adulti e agonisti 18:15-20:00.",
    category: "generale",
    publishedAt: "2026-08-18",
  },
  {
    id: "45",
    title: "Programma off-season: preparazione fisica estiva per il Taekwondo",
    slug: "programma-off-season-preparazione-estiva-taekwondo",
    excerpt:
      "Il programma dello staff tecnico per l'off-season: 3 sedute a settimana, senza attrezzatura, per mantenere forza, resistenza e mobilità durante l'estate.",
    category: "generale",
  },
  {
    id: "44",
    title: "Bambini vivaci e iperattivi: come lo sport aiuta disciplina, carattere e autocontrollo",
    slug: "sport-disciplina-bambini-vivaci-iperattivi",
    excerpt:
      "Come lo sport aiuta i bambini vivaci e iperattivi a canalizzare energia, sviluppare autocontrollo e migliorare comportamento e concentrazione. Il ruolo delle arti marziali a Roma.",
    category: "bambini",
    publishedAt: "2026-08-25",
  },
  {
    id: "43",
    title: "Scuola, compiti e sport: come organizzare la settimana di tuo figlio",
    slug: "organizzare-settimana-scuola-sport-bambini",
    excerpt:
      "Come organizzare la settimana di un bambino tra scuola, compiti, sport e riposo: modelli con 2 o 3 allenamenti, segnali di sovraccarico e consigli per il rientro a settembre.",
    category: "generale",
    publishedAt: "2026-08-18",
  },
  {
    id: "42",
    title: "Come scegliere lo sport giusto per tuo figlio: guida per genitori a Roma",
    slug: "come-scegliere-sport-bambini-roma",
    excerpt:
      "Guida onesta per scegliere lo sport giusto per un bambino a Roma: criteri per età e temperamento, mini-schede sui principali sport e come valutare una scuola sportiva.",
    category: "bambini",
    publishedAt: "2026-08-04",
  },
  {
    id: "39",
    title: "Chiusura stagione sportiva 2025/2026: un anno di crescita e risultati",
    slug: "chiusura-stagione-sportiva-2025-2026",
    excerpt:
      "Con gli esami di cintura di inizio luglio si chiude la stagione 2025/2026 del Taekwondo Mattei Roma: argento ai Campionati Italiani di Messina, medaglie a Riccione, Fondi e al Foro Italico, esperienza internazionale in Bulgaria.",
    category: "generale",
  },
  {
    id: "41",
    title: "Taekwondo o Karate per bambini: come scegliere a Roma",
    slug: "taekwondo-vs-karate-per-bambini",
    excerpt:
      "Taekwondo o Karate per un bambino? Differenze tecniche, benefici educativi, sicurezza e perché a Roma il Taekwondo è spesso la scelta ideale per la crescita di bambini e ragazzi.",
    category: "bambini",
  },
  {
    id: "40",
    title: "Taekwondo a Roma: costi, prezzi e guida completa alle spese 2026",
    slug: "costi-taekwondo-roma",
    excerpt:
      "Guida completa e trasparente ai costi del Taekwondo a Roma: quota di iscrizione, mensilità, dobok, protezioni, tesseramento FITA e spese per gare. Prezzi 2026 e cosa valutare prima di scegliere una scuola.",
    category: "generale",
  },
  {
    id: "38",
    title: "Esami passaggio di cintura Luglio 2026",
    slug: "esami-sociali-cintura-luglio-2026",
    excerpt:
      "Il 3 luglio 2026 si sono svolti gli esami sociali di passaggio di cintura del Taekwondo Mattei Roma: nuove cinture gialle, mezza verde e blu per i nostri bambini.",
    category: "bambini",
  },
  {
    id: "37",
    title: "Gran Prix di Roma al Foro Italico: oro per Roberto Destro al torneo Kim & Liù",
    slug: "gran-prix-roma-kim-e-liu-2026",
    excerpt:
      "Dal 5 al 7 giugno 2026 al Foro Italico di Roma, il Taekwondo Mattei partecipa al Gran Prix con tre giovani atleti: oro per Roberto Destro nel torneo Kim & Liù -30 kg kids.",
    category: "agonisti",
  },
  {
    id: "36",
    title: "European Grand Prix di Sofia: esperienza internazionale e nuove consapevolezze per il Taekwondo Mattei",
    slug: "european-grand-prix-sofia-2026",
    excerpt:
      "Nel weekend del 30 e 31 maggio 2026 a Sofia, Niccolò Marcelli e Andrea Gasbarre rappresentano il Taekwondo Mattei all'European Grand Prix Junior in Bulgaria.",
    category: "agonisti",
  },
];

// 6 photos for the home gallery preview — direct imports only, no chain to articles.ts
export interface HomeGalleryPhoto {
  src: string;
  alt: string;
}

export const homeGalleryPhotos: HomeGalleryPhoto[] = [
  {
    src: rossanoPodioAsset.url,
    alt: "Premiazione sul podio ai Campionati Italiani di Taekwondo di Rossano 2026",
  },
  {
    src: rossanoFlaviaMedagliaAsset.url,
    alt: "Flavia Marcellini con la medaglia d'argento ai Campionati Italiani di Rossano 2026",
  },
  {
    src: arezzoMatteoMedagliaAsset.url,
    alt: "Matteo Gasbarre con la medaglia conquistata all'Interregionale di Taekwondo di Arezzo",
  },
  {
    src: arezzoFratelliAsset.url,
    alt: "Matteo e Andrea Gasbarre, i due fratelli atleti del Taekwondo Mattei all'Interregionale di Arezzo 2026",
  },
  {
    src: messinaPodioAsset.url,
    alt: "Atleta del Taekwondo Mattei sul podio ai Campionati Italiani di Messina",
  },
  {
    src: kimLiuRoma07Asset.url,
    alt: "Atleta del Taekwondo Mattei sul podio al Gran Prix Kim & Liù al Foro Italico di Roma",
  },
];

